import { Context } from "csi/def/Context";
import Spec from "csi/core/Spec";
import csiHeading from "csi/heading/_base";
import html from "csi/html";
import React, { FunctionComponent, useCallback, useRef } from "react";

export interface SpecComponentProps {
	/** context in which to render spec */
	ctx: Context;

	/** spec to render */
	spec: Spec;
}

const SpecComponent: FunctionComponent<SpecComponentProps> = (props) => {
	const { ctx, spec } = props;
	const domRef = useRef<HTMLElement | null>();

	const contentRef = useCallback(async (domNode: HTMLElement) => {
		html.clear(domRef.current || domNode, true);

		if (domNode) {
			domRef.current = domNode;
			csiHeading.toHtml(ctx, spec.heading, domNode);
		} else {
			domRef.current = null;
		}
	}, [ctx, spec]);

	return <span ref={contentRef} />;
};

export default SpecComponent;